module.exports = __webpack_public_path__ + "static/img/profile3.09db500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/profile3.jpg
// module id = J6Hd
// module chunks = 0